<template>
  <v-card stretch>
    <div v-padding="3">
      <form-search @search="$emit('search', $event)" />
    </div>
    <v-data-table :loader="loading" @sort="$emit('sort', $event)" @loadEvent="onLoadEvent" :sort="sort"
      :headers="headers" :records="records" rowAction>
      <template slot="cell-monitoringStartDate" scope="props">
        <v-text nowrap>{{ moment(props.item.monitoringStart).format('DD.MM.YYYY') }}</v-text>
      </template>
      <template slot="cell-lastEventDate" scope="props">
        <div v-if="props.item.lastEvent != null">
          <v-text nowrap>{{ moment(props.item.lastEvent.reported).format('DD.MM.YYYY') }}</v-text>
        </div>
        <div v-else>
          <v-text nowrap>&mdash;</v-text>
        </div>
      </template>

      <template slot="cell-subjectFullName" scope="props">
        <v-text v-if="props.item.companyName">{{ props.item.companyName }}</v-text>
        <v-text v-else>{{ getFullName(props.item) }}</v-text>
      </template>

      <template slot="cell-lastEventName" scope="props">
        <div v-if="props.item.lastEvent">
          <v-text nowrap>{{ props.item.lastEvent.name }}</v-text>
        </div>
        <div v-else>
          <v-text nowrap>&mdash;</v-text>
        </div>
      </template>

      <template slot="cell-eventsToCheckOut" scope="props">
        <div class="right-align" v-padding.right="2">
          <div v-if="props.item.eventsToCheckOut" class="eventsToCheckOut">
            <span class="active"></span>
            {{ ' ' }}
            <v-text nowrap>+{{ props.item.eventsToCheckOut }}</v-text>
          </div>
          <div v-else class="eventsToCheckOut">
            <span class="inactive"></span>
            {{ ' ' }}
            <v-text nowrap>{{ props.item.eventsToCheckOut }}</v-text>
          </div>
        </div>
      </template>

      <template slot="cell-monitiringEndData" scope="props">
        <div v-if="props.item.lastData">
          <v-text nowrap>{{ moment(props.item.monitoringEnd).format('DD.MM.YYYY') }}</v-text>
        </div>
        <div v-else>
          <v-text nowrap>&mdash;</v-text>
        </div>
      </template>

    </v-data-table>

    <div v-padding="3">
      <v-pagination @click="$emit('paginate', $event)" :total="total" :display="display" :current="page" />
    </div>
    <modal-monitoring-event v-if="currentSubjectId !== null"/>
  </v-card>
</template>
<script>
import moment from "moment";
import FormSearch from "./FormSearch";
import { ModalMonitoringEvent } from "../../modal/ModalMonitoringEvent";

export default {
  name: "monitoring",
  props: {
    loading: Boolean,
    sort: Object,
    records: Array,
    currentSubjectId: Number,
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    display: {
      type: Number,
      default: 10
    },
    setCurrentSubjectId: Function,
    show: Function
  },
  components: {
    FormSearch
  },
  data() {
    return {
      headers: {
        monitoringStartDate: { label: "Дата" },
        subjectFullName: { label: "Субъект" },
        lastEventName: { label: "Последнее событие" },
        lastEventDate: { label: "Дата последнего события" },
        eventsToCheckOut: { label: "Новые события" },
        monitoringEnd: { label: "Дата окончания" }
      }
    };
  },

  components: { ModalMonitoringEvent, FormSearch },
  methods: {
    moment,
    onLoadEvent(id) {
      this.show();
      this.setCurrentSubjectId(id);
    },
    getFullName({ lastName, firstName, middleName }) {
      function toUpper(word) {
        if (!word) return '';
        const w = word.toLowerCase()
        return w.charAt(0).toUpperCase() + w.substring(1)
      }
      return `${toUpper(lastName)} ${toUpper(firstName)} ${toUpper(middleName)}`;
    }
  }
};
</script>

<style scoped>
.right-align {
  display: flex;
  justify-content: flex-end;
  padding-right: 24px;
}

.eventsToCheckOut {
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.active {
  display: inline-block;
  margin-right: 12px;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background-color: #03A9F4;
}

.inactive {
  display: inline-block;
  margin-right: 12px;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background-color: #e0e0e0;
}
</style>



// WEBPACK FOOTER //
// Monitoring.vue?42239998